export default [
    {
        name: 'cadastro-convenio-medico',
        path: 'convenio-medico',
        redirect: 'convenio-medico/index',
        component: () => import(/* webpackChunkName: 'cadastro-convenio-medico' */ '@/views/cadastro/convenio-medico/Index'),
        children: [
            {
                meta: { title: 'Lista de convênios médicos' },
                name: 'cadastro-convenio-medico-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-convenio-medico' */ '@/views/cadastro/convenio-medico/List.vue'),
            },
            {
                meta: { title: 'Cadastro de convênio médico' },
                name: 'cadastro-convenio-medico-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-convenio-medico' */ '@/views/cadastro/convenio-medico/Form.vue'),
            },
            {
                meta: { title: 'Edição de convênio médico' },
                name: 'cadastro-convenio-medico-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* webpackChunkName: 'cadastro-convenio-medico' */ '@/views/cadastro/convenio-medico/Form.vue'),
            },
        ],
    },
]